import type {
  BaseOrderSettings,
  BotSettings,
  GridSettings,
  StopLossSettings,
  TakeProfitSettings,
  TradingGuardSettings,
  TrailingStopLossSettings,
} from "@/types/botSettings";
import {
  BOT_SETTINGS_VERSION,
  DepositMode,
  GridExitMode,
  PairCycleTpExitMode,
} from "@/types/botSettings";

// Дефолтные настройки контроля pump/dump
export const DEFAULT_TRADING_GUARD_SETTINGS: TradingGuardSettings = {
  enabled: false,
  timeout_hours: 4,
  min_move: 5, // 5%
  max_move: 50, // 50%
};

// Дефолтные настройки стоп-лосса
export const DEFAULT_STOP_LOSS_SETTINGS: StopLossSettings = {
  enabled: false,
  stop_loss: 2, // 2%
  placing_timeout: 30, // 30 секунд
  timeout_after_execution: 0, // 0 секунд = без паузы после SL
};

// Дефолтные настройки трейлинг стоп-лосса
export const DEFAULT_TRAILING_STOP_LOSS_SETTINGS: TrailingStopLossSettings = {
  enabled: false, // отключен по умолчанию
  trigger_price_step: 0.0, // 0% по умолчанию
  order_price_step: 0.0, // 0% по умолчанию
};

// Дефолтные настройки тейк-профита
export const DEFAULT_TAKE_PROFIT_SETTINGS: TakeProfitSettings = {
  orders: [
    {
      position_fraction: 100, // 100% позиции (в UI - проценты)
      tp_rate_ratio: 1, // 1% тейк-профит (в UI - проценты)
      exit_on_signal: false,
    },
  ],
};

// Дефолтные настройки grid-группы (GridSettings; проценты в UI)
export const DEFAULT_GRID_SETTINGS: GridSettings = {
  enabled: false,
  anchor_slot: null,
  levels_count: 10,
  step_ratio: 0.5, // 0.5% — защита от комиссионного «прогрева» на плотной сетке
  exit_mode: GridExitMode.TP_LIMIT,
  close_bag_on_negative_pnl: false,
};

export const DEFAULT_BASE_ORDER_SETTINGS: BaseOrderSettings = {
  deposit: undefined as unknown as number,
  deposit_mode: DepositMode.BALANCE_PERCENT,
  deposit_percent: undefined,
};

// Дефолтный pair-cycle модуль (take_profit / risk_guard / price_cutter)
export const DEFAULT_PAIR_CYCLE_SETTINGS = {
  take_profit: {
    enabled: false,
    threshold: 0,
    exit_mode: PairCycleTpExitMode.INSTANT,
    callback_ratio: 0,
  },
  risk_guard: { enabled: false, max_price_gap: 0, max_deposit_loss: 0 },
  price_cutter: {
    enabled: false,
    min_price_movement_ratio: 0,
    mid_center_trigger: false,
  },
};

export const DEFAULT_BOT_SETTINGS: BotSettings = {
  settings_version: BOT_SETTINGS_VERSION,
  cycle: {
    max_hedge_pairs: 1,
    per_pair_trading: false,
    pair_entry_mode: "PARALLEL",
    min_pair_open_interval_minutes: 0,
    capital_allocation_mode: "EQUAL",
    support_pool_ratio: 0.7,
    margin_mode: "cross",
    allowed_direction: "both",
    long_leverage: 10,
    short_leverage: 10,
  },
  pair_configs: [
    {
      settings: {
        position_mode: "HEDGE",
        base_order: DEFAULT_BASE_ORDER_SETTINGS,
      },
      trading: {
        entry_type: "SIGNAL",
        exit_type: "SIGNAL",
        entry_indicators: [],
        exit_indicators: [],
        take_profit: {
          enabled: true,
          orders: DEFAULT_TAKE_PROFIT_SETTINGS.orders,
        },
        stop_loss: DEFAULT_STOP_LOSS_SETTINGS,
        trailing_stop_loss: DEFAULT_TRAILING_STOP_LOSS_SETTINGS,
        trading_guard: DEFAULT_TRADING_GUARD_SETTINGS,
        pair_cycle: DEFAULT_PAIR_CYCLE_SETTINGS,
        grid: DEFAULT_GRID_SETTINGS,
      },
    },
  ],
};
